import { axios } from '@/utils/request'

export function getTime () {
  return axios({
    url: '/adult/time',
    method: 'GET'
  })
}

export function addObj (obj) {
  return axios({
    url: '/adult/apply',
    method: 'POST',
    data: obj
  })
}

export function getCode () {
  return axios({
    url: '/adult/code',
    method: 'GET'
  })
}

export function getDetail (obj) {
  return axios({
    url: '/adult/detail',
    data: obj,
    method: 'POST'
  })
}

export function isIdCard (idCard) {
  return axios({
    url: '/adult/isIdCard/' + idCard,
    method: 'GET'
  })
}

export function adultApplyOption () {
  return axios({
    url: '/adult/option/adultApplyOption',
    method: 'GET'
  })
}

export function getApplyUserInfoById (id) {
  return axios({
    url: '/adult/getApplyUserInfoById/' + id,
    method: 'GET'
  })
}

export function editApplyAdult (params) {
  return axios({
    url: '/adult/editApplyAdult',
    data: params,
    method: 'POST'
  })
}

export function adminEditApplyAdult (params) {
  return axios({
    url: '/adult/admin/editApplyAdult',
    data: params,
    method: 'POST'
  })
}